export const cacheKey = {
	GET_VOLUNTEER: 'get-volunteer',
	GET_VOLUNTEER_DASHBOARD_DATA: 'get-volunteer-dashboard-data',
	GET_PARTY: 'get-party',
	GETRESULTAPALYTICS: 'get-result-analytics',
	GETPUINWARD: 'get-polling-unit-in-ward',
	CREATEWARDRESULT: 'create-ward-result',
	CREATELGAESULT: 'create-lga-result',
	CREATESTATERESULT: 'create-state-result',
	CREATEPURESULT: 'create-pu-result',
	UPDATE_ELECTION: 'update-election',
	GETWARDINLGA: 'get-ward-in-lga',
	GETCONSTITUENCYSTATEBYID: 'get-constituency-state-by-id',
	GETIREVELECTION: 'get-irev-election',
} as const;
